import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<Saas::SaasSharedUiShim @className=\"disable-all-glass-global-css\" @componentName=\"UpsellPill\" @feature={{this.feature}} @size={{this.size}} @shimTag={{this.shimTag}} @popoverPlacement={{this.popoverPlacement}} />", {
  moduleName: "@dashboard/shared-ui/components/saas/upsell-pill.hbs"
});